/**
 * SubscriptionPage – plan selection and checkout.
 */
import Card from '../../shared/ui/Card.jsx';
import Button from '../../shared/ui/Button.jsx';
import Display from '../../shared/ui/Display.jsx';
import Title from '../../shared/ui/Title.jsx';
import Body from '../../shared/ui/Body.jsx';
import Stat from '../../shared/ui/Stat.jsx';
import styles from './SubscriptionPage.module.css';

const PLANS = [
  {
    id: 'monthly',
    name: 'Pro Monthly',
    price: '$9',
    period: 'PER MONTH',
    features: [
      'Unlimited lift logging',
      'Full leaderboard access',
      'Challenge entries',
      'Progress analytics',
    ],
    highlighted: false,
    cta: 'Subscribe monthly',
    priceId: 'price_monthly',
  },
  {
    id: 'annual',
    name: 'Pro Annual',
    price: '$79',
    period: 'PER YEAR',
    features: [
      'Everything in Pro Monthly',
      'Save 27% vs monthly',
      'Early access to new features',
      'Priority support',
    ],
    highlighted: true,
    cta: 'Subscribe annually',
    priceId: 'price_annual',
  },
];

async function handleCheckout(priceId) {
  // Checkout handler — integrate with Stripe or Firebase Extension
  console.log('checkout', priceId);
}

export function SubscriptionPage() {
  return (
    <div className={styles.page}>
      <div className={styles.hero}>
        <Display as="h1" size="xl">Go Pro</Display>
        <Body tone="secondary" style={{ marginTop: '0.5rem' }}>
          Unlock full access — compete, track, dominate.
        </Body>
      </div>

      <div className={styles.plans}>
        {PLANS.map((plan) => (
          <Card
            key={plan.id}
            frame={plan.highlighted ? 'gold' : null}
            padding="lg"
            className={styles.planCard}
          >
            <Title style={{ marginBottom: '1rem' }}>{plan.name}</Title>

            <Stat
              label={plan.period}
              value={plan.price}
              className={styles.priceStat}
            />

            <ul className={styles.features}>
              {plan.features.map((f) => (
                <li key={f}>
                  <Body>{f}</Body>
                </li>
              ))}
            </ul>

            <Button
              variant="primary"
              size="lg"
              onClick={() => handleCheckout(plan.priceId)}
              style={{ width: '100%', marginTop: '1.5rem' }}
            >
              {plan.cta}
            </Button>
          </Card>
        ))}
      </div>
    </div>
  );
}
